import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';
import { Part } from './part';

@Injectable()
export class PartService implements Resolve<any> {
  public rows: any;
  public onPartListChanged: BehaviorSubject<any>;
  public lastCreatedPartId: number | null = null;

  constructor(private _httpClient: HttpClient, public _authenticationService: AuthenticationService) {
    this.onPartListChanged = new BehaviorSubject({});
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return new Promise<void>((resolve, reject) => {
      Promise.all([this.getAllParts()]).then(() => {
        resolve();
      }, reject);
    });
  }

  getAllParts(ignoreSubjects = false): Promise<Part[]> {
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.get(`${environment.apiUrl}/v1/parts`, { headers }).subscribe((response: any) => {
        this.rows = response.results;
        if (!ignoreSubjects) {
          this.onPartListChanged.next(this.rows);
        }
        resolve(this.rows);
      }, reject);
    });
  }

  createPart(part, ignoreSubjects = false): Promise<Part> {
    delete part.id;
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.post(`${environment.apiUrl}/v1/parts`, part, { headers }).subscribe((response: any) => {
        this.lastCreatedPartId = response?.id ?? null;
        if (!ignoreSubjects) {
          this.getAllParts();
        }
        resolve(response);
      }, reject);
    });
  }

  updatePart(part): Promise<void> {
    part = Object.fromEntries(
      ['id', 'name', 'notes']
        .filter(k => k in part)
        .map(k => [k, part[k]])
    );
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.patch(`${environment.apiUrl}/v1/parts/${part.id}`, part, { headers }).subscribe((response: any) => {
        this.getAllParts();
        resolve();
      }, reject);
    });
  }
}
